<script>
	import LinkButton from "../../components/LinkButton.svelte";
	export let id;
	export let slideProgress;
	export let content = {};
	export let forSubscribers;
</script>

<div class="content t-info">
	<div class="information">
		<div class="t-info-title">
			{@html content.information.heading}
		</div>
		<div class="t-copy-sans">{@html content.information.text}</div>
		<LinkButton link={content.information.button_link} text={content.information.button_text} color="black" />
	</div>

	<div class="sep" />
	<div class="meinung">
		<div class="t-info-title-small">{@html content.meinung.heading}</div>
	</div>
	<div class="kontakt t-copy-sans">
		<div>
			<img class="icon" id="phone" src="{PATH}assets/images/icons/tel.svg" alt="" /><a href={content.kontakt.phone_link}
				>{@html content.kontakt.phone}</a
			>
		</div>
		<div>
			<img class="icon" id="email" src="{PATH}assets/images/icons/email.svg" alt="" /><a
				href={content.kontakt.email_link}>{@html content.kontakt.email}</a
			>
		</div>
	</div>
	<div class="sep" />
</div>

<style lang="scss">
	.content {
		max-width: 534px;
		margin: 0 auto;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 70px 0;
	}

	.information {
		margin-bottom: 80px;
	}

	.meinung {
		margin-bottom: 30px;

		@media (max-width: $breakpoint-mobile) {
			margin-bottom: 25px;
		}
	}

	.kontakt {
		margin-top: 0px !important;

		> div {
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-content: center;
			margin-bottom: 10px;

			@media (max-width: $breakpoint-mobile) {
				// justify-content: flex-start;
			}
		}

		a {
			text-shadow: none;
			text-decoration: none;

			&:hover {
				color: #000;
				text-decoration: underline;
			}

			@media (max-width: $breakpoint-mobile) {
				text-decoration: underline;
			}
		}
	}

	.icon {
		margin-right: 10px;

		&#phone {
			width: 25px;
			height: 25px;
			position: relative;
			top: 3px;
		}

		&#email {
			width: 29px;
			height: 29px;
		}
	}

	.sep {
		margin: 30px auto;
		width: 100%;
		height: 1px;
		background: #c9c9c9;

		@media (max-width: $breakpoint-mobile) {
			display: none;
		}
	}
</style>
